import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Button } from "@ts-digital/vrc";
import { Input, notification } from "antd";
import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { getBanks, getProducts } from "../../../store/actions/tspay/banks";
import Stepper from "../../classificator/stepper";
import LoaderSimple from "../../general/loader";
import { getBankLogo } from "../bank-logos";
import "./style.css";
import uuidv4 from "uuid/v4";
import {
  getConsentsAccounts,
  requestConsentsRecurring,
  requestConsentsToAccountsList
} from "../../../store/actions/tspay/consents";
import { refreshAccount } from "../../../store/actions/tspay";

const defConsentData = {
  consentAccountList: {},
  consentAccountListGet: [],
  consentAccountListUuid: null,
  consentAccountListSelected: null,
  consentRecurring: {},
  consentRecurringUuid: null
};

const TSPayAddAccountPage = props => {
  const { isFullscreenOverlay, onClose } = props;
  const dispatch = useDispatch();
  const auth = useSelector(state => state.auth);
  const main = useSelector(state => state.main);
  const tspay = useSelector(state => state.tspay);
  const banks = tspay.resources.banks;
  const products = tspay.resources.products;
  const [step, setStep] = useState(1);
  const [selectedBank, setSelectedBank] = useState(null);
  const [selectedProduct, setSelectedProduct] = useState(null);
  const [selectedAccount, setSelectedAccount] = useState([]);
  const [searchBankValue, setSearchBankValue] = useState(undefined);
  const [searchBank, setSearchBank] = useState(null);
  const [stepConsent, setStepConsent] = useState(1);
  const [refreshedAccounts, setRefreshedAccounts] = useState(0);
  const [consentData, setConsentData] = useState(defConsentData);

  useEffect(() => {
    // Set up event handler to produce text for the window focus event
    window.addEventListener("focus", checkConsentsOnFocus);
  }, []);

  useEffect(() => () => {
    // remove focus handler event
    window.removeEventListener("focus", checkConsentsOnFocus);
  },
  []);

  useEffect(() => {
    dispatch(getBanks(
      auth, main.accountantUuidSelected, main.companyUuidSelected
    ));
  }, []);

  useEffect(() => {
    setSelectedBank(null);
  }, []);

  useEffect(() => {
    if (step === 1) {
      clearAllMask();
    }
    if (step === 2) {
      dispatch(getProducts(
        auth,
        main.accountantUuidSelected,
        main.companyUuidSelected,
        selectedBank.id
      ));
    }
    if (step === 3 && stepConsent === 1) {
      beginConsentFlow();
    }
  }, [step]);

  useEffect(() => {
    if (main.widgets.fullscreenOverlay.visible) {
      dispatch(getBanks(
        auth, main.accountantUuidSelected, main.companyUuidSelected
      ));
    }
  }, [main.widgets.fullscreenOverlay.visible]);

  useEffect(() => {
    if (consentData.consentAccountList.scaManagerRedirectUrl) {
      setStepConsent(2);
      window
        .open(consentData.consentAccountList.scaManagerRedirectUrl, "_blank")
        .focus();
    }
  }, [consentData.consentAccountList]);

  useEffect(() => {
    if (stepConsent === 3) {
      dispatch(getConsentsAccounts(
        auth,
        main.accountantUuidSelected,
        main.companyUuidSelected,
        consentData.consentAccountList.consentId
      )).then(res => {
        setConsentData({
          ...consentData,
          consentAccountListGet: res.accounts
        });
      });
    }
    if (stepConsent === 4) {
      let bodyAccountsRequest = [];
      selectedAccount.map(acc => {
        return bodyAccountsRequest.push({
          resourceId: acc.resourceId,
          iban: acc.iban,
          currency: acc.currency
        });
      });
      dispatch(requestConsentsRecurring(
        auth,
        main.accountantUuidSelected,
        main.companyUuidSelected,
        selectedBank.id,
        selectedProduct.aspspProductCode,
        {
          transactions: bodyAccountsRequest,
          balances: bodyAccountsRequest
        }
      )).then(res => {
        localStorage.setItem("tspayConsentRecurringConsentId", res.consentId);
        window.open(res.scaManagerRedirectUrl);
        setStepConsent(5);
        setConsentData({
          ...consentData,
          consentRecurring: res
        });
      });
    }
  }, [stepConsent]);

  useEffect(() => {
    if (consentData.consentAccountListGet.length > 0) {
      let tmpList = [];
      consentData.consentAccountListGet.map(acc => {
        if (acc.currency === "EUR") {
          tmpList.push(acc);
        }
        return null;
      });
      setSelectedAccount(tmpList);
    }
  }, [consentData.consentAccountListGet]);

  useEffect(() => {
    const handler = event => {
      if (event.data) {
        checkConsentCompleted(event);
      }
    };

    window.addEventListener("message", handler);

    // clean up
    return () => window.removeEventListener("message", handler);
  }, []);

  useEffect(() => {
    if (stepConsent === 6 && refreshedAccounts === selectedAccount.length) {
      if (onClose) {
        onClose();
      }
    }
  }, [refreshedAccounts]);

  const clearAllMask = () => {
    // pulisco localstorage
    for (let key in localStorage) {
      if (
        key.indexOf("tspayConsentAccountList_") > -1 ||
        key.indexOf("tspayConsentRecurring_") > -1
      ) {
        localStorage.removeItem(key);
      }
    }
    // pulisco consentData
    setConsentData(defConsentData);
    setStepConsent(1);
  };

  const checkConsentsOnFocus = () => {
    if (
      stepConsent === 2 &&
      localStorage.getItem(`tspayConsentAccountList_${consentData.consentAccountListUuid}`) === "done"
    ) {
      setStepConsent(3);
    }
  };

  const checkConsentCompleted = event => {
    if (event.data && event.data.consentCompleted) {
      if (
        event.data.consentCompleted.indexOf("tspayConsentsAccountsListCompleted") > -1
      ) {
        setStepConsent(3);
      }
      if (
        event.data.consentCompleted.indexOf("tspayConsentsRecurringCompleted") >
        -1
      ) {
        dispatch(getConsentsAccounts(
          auth,
          main.accountantUuidSelected,
          main.companyUuidSelected,
          localStorage.getItem("tspayConsentRecurringConsentId")
        ))
          .then(res => {
            setStepConsent(6);
            setSelectedAccount(res.accounts);
            let cn = 0;
            res.accounts.map(acc => {
              cn++;
              dispatch(refreshAccount(
                auth,
                main.accountantUuidSelected,
                main.companyUuidSelected,
                acc.accountId
              ))
                .then(res => {
                  if (cn === res.accounts.length) {
                    if (onClose) {
                      onClose();
                    }
                  }
                  setRefreshedAccounts(refreshedAccounts + 1);
                })
                .catch(err => {
                  if (cn === res.accounts.length) {
                    if (onClose) {
                      onClose();
                    }
                  }
                  setRefreshedAccounts(refreshedAccounts + 1);
                });
              return null;
            });
          })
          .catch(err => {
            if (onClose) {
              onClose();
            }
          });
      }
    }
  };

  const beginConsentFlow = () => {
    let tmpUuid = uuidv4();
    dispatch(requestConsentsToAccountsList(
      auth,
      main.accountantUuidSelected,
      main.companyUuidSelected,
      selectedBank.id,
      selectedProduct.aspspProductCode,
      "account",
      tmpUuid
    ))
      .then(response => {
        setConsentData({
          ...consentData,
          consentAccountList: response,
          consentAccountListUuid: tmpUuid
        });
        localStorage.setItem(`tspayConsentAccountList_${tmpUuid}`, "pending");
      })
      .catch(() => {
        setStep(2);
        notification.open({
          message: "Errore",
          description: "Si è verificato un errore durante il consenso",
          className: "dbx-tspay-consent-error-notify"
        });
      });
    return;
  };

  const onAccountSelection = account => {
    let tmpList = [];
    let tmpSel = selectedAccount.find(x => x.accountId === account.accountId);
    if (tmpSel) {
      selectedAccount.map(acc => {
        if (acc.accountId !== account.accountId) {
          tmpList.push(acc);
        }
        return null;
      });
    } else {
      tmpList = [...selectedAccount];
      tmpList.push(account);
    }
    return setSelectedAccount(tmpList);
  };

  const renderBanks = () => {
    let items = [];
    if (banks.length === 0 && tspay.resources.isGettingBanks) {
      items.push(<div className="dbx-tspay-account-add-banks-loading">
        <LoaderSimple />
      </div>);
    }
    banks.map(bank => {
      const logo = getBankLogo(bank.logo);
      if (
        !searchBank ||
        searchBank === "" ||
        (searchBank &&
          (bank.aspspCode.toLowerCase().indexOf(searchBank.toLowerCase()) >
            -1 ||
            bank.businessName.toLowerCase().indexOf(searchBank.toLowerCase()) >
              -1))
      ) {
        items.push(<div className="dbx-tspay-account-add-bank-card">
          <div className="dbx-tspay-account-add-bank-card-left">
            <div className="dbx-tspay-account-add-bank-card-abi">
                ABI: {bank.aspspCode}
            </div>
            <div className="dbx-tspay-account-add-bank-logo">
              {logo ? <img src={logo} alt="" /> : null}
            </div>
            <div className="dbx-tspay-account-add-bank-name">
              {bank.businessName}
            </div>
          </div>
          <div className="dbx-tspay-account-add-bank-card-right">
            <div
              onClick={() => {
                setSelectedBank(bank);
                setStep(2);
              }}
              className="dbx-tspay-account-add-bank-choose"
            >
              <FontAwesomeIcon icon={["far", "arrow-right"]} />
            </div>
          </div>
        </div>);
      }
      return null;
    });
    return items;
  };

  const renderProducts = () => {
    let items = [];
    if (products.length === 0 && tspay.resources.isGettingProducts) {
      items.push(<div className="dbx-tspay-account-add-products-loading">
        <LoaderSimple />
      </div>);
    }
    products.map(product => {
      const logo = getBankLogo(selectedBank.logo);
      return items.push(<div className="dbx-tspay-account-add-product-card">
        <div className="dbx-tspay-account-add-product-card-left">
          <div className="dbx-tspay-account-add-product-logo">
            {logo ? <img src={logo} alt="" /> : null}
          </div>
          <div className="dbx-tspay-account-add-product-name">
            {product.aspspProductSuggestedLabel}
          </div>
        </div>
        <div className="dbx-tspay-account-add-product-card-right">
          <div
            onClick={() => {
              setSelectedProduct(product);
              setStep(3);
            }}
            className="dbx-tspay-account-add-product-choose"
          >
            <FontAwesomeIcon icon={["far", "arrow-right"]} />
          </div>
        </div>
      </div>);
    });
    return items;
  };

  const renderAccounts = () => {
    let items = [];
    if (tspay.consents.isGettingConsentAccounts) {
      items.push(<div className="dbx-tspay-account-add-accounts-loading">
        <LoaderSimple message="Caricamento conti correnti" />
      </div>);
    }
    consentData.consentAccountListGet.map(account => {
      if (account.currency === "EUR") {
        const logo = getBankLogo(selectedBank.logo);
        items.push(<div
          onClick={() => {
            onAccountSelection(account);
          }}
          className={
            "dbx-tspay-account-add-account-card" +
              (selectedAccount.find(x => x.accountId === account.accountId)
                ? " selected"
                : "")
          }
        >
          <div className="dbx-tspay-account-add-account-card-left">
            <div className="dbx-tspay-account-add-account-selected">
              <FontAwesomeIcon
                icon={[
                  "far",
                  selectedAccount.find(x => x.accountId === account.accountId)
                    ? "check-square"
                    : "square"
                ]}
              />
            </div>
            <div className="dbx-tspay-account-add-account-logo">
              {logo ? <img src={logo} alt="" /> : null}
            </div>
            <div className="dbx-tspay-account-add-account-name">
              {account.iban}
            </div>
          </div>
        </div>);
      }
      return null;
    });
    return items;
  };

  let logo;
  if (selectedBank) {
    logo = getBankLogo(selectedBank.logo);
  }

  return (
    <div
      className={
        "dbx-tspay-account-add-root" +
        (isFullscreenOverlay ? " isFullscreenOverlay" : "")
      }
    >
      <div className={"dbx-tspay-account-add-header"}>
        <div className={"dbx-tspay-account-add-steps"}>
          <Stepper
            setCurrentStep={() => {}}
            currentStep={step}
            readOnly
            steps={[
              { number: 1, title: "Banca" },
              { number: 2, title: "Prodotto" },
              { number: 3, title: "Conto" }
            ]}
          />
        </div>
      </div>
      {step === 1 && (
        <div className={"dbx-tspay-account-add-filter"}>
          <Input
            allowClear
            value={searchBankValue}
            onChange={e => setSearchBankValue(e.currentTarget.value)}
            onKeyPress={e => {
              if (e.key === "Enter") {
                setSearchBank(searchBankValue);
              }
            }}
            placeholder="Cerca banca per ABI o per nome"
            suffix={
              <Button
                onClick={() => {
                  setSearchBank(searchBankValue);
                }}
              >
                <FontAwesomeIcon icon={["far", "search"]} />
              </Button>
            }
          />
        </div>
      )}
      {step === 1 && (
        <div className={"dbx-tspay-account-add-banks"}>{renderBanks()}</div>
      )}
      {step === 2 && (
        <div className={"dbx-tspay-account-add-products"}>
          {renderProducts()}
        </div>
      )}
      {step === 3 &&
        (tspay.consents.isRequestingConsentList ||
        tspay.consents.isRequestingConsentRecurring ||
        tspay.consents.isGettingConsentAccounts ? (
            <div className="dbx-tspay-account-add-waiting-loader">
              <LoaderSimple />
            </div>
          ) : (
            <div className={"dbx-tspay-account-add-account"}>
              {stepConsent === 2 && (
                <div className="dbx-tspay-account-add-waiting-card">
                  <div className="dbx-tspay-account-add-waiting-logo">
                    <img src={logo} alt="" />
                  </div>
                  <div className="dbx-tspay-account-add-waiting-text">
                  Siamo in attesa della conferma del consenso presso i servizi
                  della tua banca.
                  </div>
                  <div className="dbx-tspay-account-add-waiting-button">
                    <Button onClick={() => setStep(1)}>ANNULLA OPERAZIONE</Button>
                  </div>
                </div>
              )}
              {stepConsent === 3 && (
                <div className={"dbx-tspay-account-add-accounts"}>
                  {renderAccounts()}
                </div>
              )}
              {stepConsent === 5 && (
                <div className="dbx-tspay-account-add-waiting-card">
                  <div className="dbx-tspay-account-add-waiting-logo">
                    <img src={logo} alt="" />
                  </div>
                  <div className="dbx-tspay-account-add-waiting-text">
                  Siamo in attesa della conferma del consenso presso i servizi
                  della tua banca.
                  </div>
                  <div className="dbx-tspay-account-add-waiting-button">
                    <Button onClick={() => setStep(1)}>ANNULLA OPERAZIONE</Button>
                  </div>
                </div>
              )}
            </div>
          ))}
      <div className="dbx-tspay-account-add-footer">
        {stepConsent === 3 && (
          <Button
            disabled={selectedAccount.length === 0}
            onClick={() => setStepConsent(4)}
          >
            Collega conti
          </Button>
        )}
      </div>
    </div>
  );
};

export default TSPayAddAccountPage;
